mutation DeleteAllFacebookInstagramData {
    deleteAllFacebookInstagramData
}
